export const settlementAdjustment = {
  title: "Completar datos de la reserva",
  close: "Cerrar",
  loading: "Cargando…",
  intro: "Para reservas importadas sin desglose o antiguas: completa lo que no trajo el canal. Lo que dejes vacío se calcula como siempre. No cambia la factura del huésped, solo la liquidación al propietario.",
  price: "Precio de la reserva",
  guestCleaning: "Limpieza incluida en el precio",
  guestCleaningHint: "Lo que pagó el huésped por la limpieza dentro del precio. Ahora: {now}.",
  otaCommission: "Comisión real de la OTA (sin IVA)",
  otaCommissionHint: "Ahora: {now}.",
  otaCommissionHintEstimated: "Ahora se estima con el % del anuncio: {now}. Pon la que cobró el canal.",
  managerCleaning: "Limpieza que te quedas en esta reserva",
  managerCleaningHint: "Sustituye al importe fijo del anuncio solo en esta reserva. Ahora: {now}.",
  note: "Nota",
  notePlaceholder: "Ej. reserva antigua, limpieza a 40 €",
  reset: "Volver a lo automático",
  cancel: "Cancelar",
  save: "Guardar",
  saving: "Guardando…",
  saved: "Reserva completada: la liquidación se ha recalculado.",
  loadError: "No se pudieron cargar los datos de la reserva.",
  saveError: "No se pudo guardar.",
  invalid: "Revisa los importes: tienen que ser números positivos.",
};
